import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export function HeadedCard({ title, children }) {
    return (
        <HeadedCardContainer>
            <HeadedCardHeader>{title}</HeadedCardHeader>
            <HeadedCardContent>{children}</HeadedCardContent>
        </HeadedCardContainer>
    );
}

HeadedCard.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.node, PropTypes.array])
};

const HeadedCardContainer = styled.div`
    width: 100%;
    border-radius: 5px;
    margin: 1rem 0;
`;

const HeadedCardHeader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    font-size: 1rem;

    background-color: ${props => props.theme.secondary};
    color: white;
    border-radius: 3px 3px 0 0;
`;

const HeadedCardContent = styled.div`
    padding: 1rem;
    border: 1px solid rgba(110, 101, 94, 0.5);
    border-radius: 0 0 3px 3px;
    border-top: none;
`;
